import React from "react";

import { Control, RegisterOptions } from "react-hook-form";

import { copy } from "shared/assets/copy";
import { getSortedCountries } from "shared/utils";
import {
  Select,
  CountryOption,
  CountryValue,
  InputFieldProps,
} from "shared/components";
import { Globe } from "shared/assets/icons";

import { ISelectOption } from "./types";

interface CountrySelectProps extends InputFieldProps {
  control: Control;
  validation?: RegisterOptions;
  setFieldValue?: (field: string, value: string | null) => void;
}

export const CountrySelect: React.FC<CountrySelectProps> = ({
  value,
  placeholder,
  ...rest
}) => {
  const countries = getSortedCountries();

  const countryOptions = countries.map(
    ({ code, name, flag }): ISelectOption => ({
      value: code,
      label: name,
      iconComponent: flag,
    })
  );

  return (
    <Select
      {...rest}
      value={value}
      placeholder={placeholder || copy.form.selectCountry}
      options={countryOptions}
      SelectValue={CountryValue}
      Option={CountryOption}
      prefixIcon={Globe}
      isSearchable
    />
  );
};
